<template>
  <el-card style="height: 100vh;">
    <el-form :model="form" label-width="100px">
      <el-form-item label="活动类型">
        <el-select
          :disabled="!isEdit"
          v-model="form.type">
          <el-option label="单品折扣" value="single" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动标题">
        <el-input
          :disabled="!isEdit"
          v-model="form.title" />
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :disabled-date="disabledDate"
          :disabled="!isEdit"
        />
      </el-form-item>

      <el-form-item label="活动商品">
        <el-button type="primary"
                   :disabled="!isEdit"
                   @click="dialogVisible = true">选择商品</el-button>

      </el-form-item>
      <el-table
        :data="form.products"
        border
        style="margin: 12px 0 32px;margin-left: 100px;width: 60vw;"
      >
        <el-table-column prop="spuCode" label="商品SPU" />
        <el-table-column prop="spuName" label="商品名称" />
        <el-table-column prop="stockNum" label="库存" />
        <el-table-column label="促销折扣(%)">
          <template #default="{ row }">
            <el-input
              :disabled="!isEdit"
              v-model="row.discount" />
          </template>
        </el-table-column>

        <el-table-column label="总限量">
          <template #default="{ row }">
            <el-input
              :disabled="!isEdit"
              v-model="row.totalLimit" />
          </template>
        </el-table-column>
        <el-table-column label="每人限量">
          <template #default="{ row }">
            <el-input
              :disabled="!isEdit"
              v-model="row.perPersonLimit" />
          </template>
        </el-table-column>
      </el-table>

      <el-form-item>
        <div class="form-footer">
          <el-button @click="$router.back()">取消</el-button>
          <el-button
            v-if="isEdit"
            type="primary" @click="publishAct">发布</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-card>

  <ProductDialog v-model:visible="dialogVisible" @confirm="addProducts" />
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import {dateUtil, onMounted, useCurrentAppInstance} from '@zto/zpage'
const app = useCurrentAppInstance()
import ProductDialog from './ProductDialog.vue'
import {ElMessage} from "element-plus";
import {dayjs} from "@zto/zpage-runtime/utils/date";

const dialogVisible = ref(false)
const isEdit = ref(false)
const form = reactive({
  type: 'single',
  title: '',
  time: [],
  products: [] as any[]
})

function getHashQuery() {
  const hash = window.location.hash || ''
  const queryStr = hash.includes('?') ? hash.split('?')[1] : ''
  return new URLSearchParams(queryStr)
}

async function queryData(){
  const query = getHashQuery()
  const id = query.get('id')
  const activityCode = query.get('activityCode')
  if (activityCode){
    isEdit.value = query.get('type')==='edit'
    const resp = await app.request({
      api:'api/pc/activity/queryInfo',
      params: {
        activityCode: activityCode,
      }
    })
    form.title = resp.activityTitle
    form.time = [
      dateUtil.parseAndFormat(resp.startDate),
      dateUtil.parseAndFormat(resp.endDate)
    ]
    form.activityCode = activityCode
    form.type = resp.activityType
    form.products = resp.goodsList.map((item)=>{
      item.stockNum = item.stock
      return item;
    })
  }
  else {
    isEdit.value = true
  }
  // form = {
  //   type: resp.activityType,
  //   title: resp.activityTitle,
  //   time: [
  //     dateUtil.parseAndFormat(resp.startDate),
  //     dateUtil.parseAndFormat(resp.endDate)
  //   ],
  //   products: resp.goodsList
  // }
}

onMounted(()=>{
  queryData()
})



const disabledDate = (time: Date) => {
  return time.getTime() < dayjs().startOf('day').valueOf()
}

const addProducts = (rows:any[]) => {
  form.products.push(...rows)
}

const publishAct = async () => {
  console.log(form)
  const myStartDate = dateUtil.parseAndFormat(form.time[0])
  const resp = await app.request({
    api:'api/pc/activity/saveOrUpdate',
    params: {
      activityType: 1,
      activityTitle: form.title,
      startDate: myStartDate,
      endDate: dateUtil.parseAndFormat(form.time[1]),
      goodsList: form.products,
      activityCode:form.activityCode?form.activityCode:undefined
    }
  })
  ElMessage.success('创建成功')
  setTimeout(()=>{
    app.router.back()
  },1000)
}
</script>

<style scoped>
.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}
</style>
